<script>
import {
    BCard, BRow, BCol, BCardTitle, BCardHeader
} from 'bootstrap-vue'

export default {
    components: {
        BCard, BRow, BCol, BCardTitle, BCardHeader
    },
    props: {
        section: {
            required: true,
            type: Object
        }
    }
}
</script>

<template>
    <b-row>
        <b-col>
            <b-card no-body border-variant="light">
                <b-card-header>
                    <b-card-title>{{ $t('Page(SentRequest):Component(Text):validity-of-information') }}</b-card-title>
                </b-card-header>
                <div class="card-body">
                    <p>
                        <strong>{{ section.validityOfDeclaration }} {{ $t('Component(Text):months') }}</strong>
                    </p>
                </div>
            </b-card>
        </b-col>
    </b-row>
</template>
